import gql from 'graphql-tag';

export const CERTIFICATION_RECORD_ATTACHMENT_FRAGMENT = gql`
  fragment CertificationRecordAttachment on CertificationRecordAttachment {
    id
    fileUrl
    fileType
    deletedOn
    createdOn
  }
`;
